module.exports = __webpack_public_path__ + "img/discount.51a76505.svg";